import { EventsInsightsResponse } from 'src/pages/visual-events/data/types/VisualEvents';
import { EventNamesResponse } from 'src/types';
import { createController, createControllerEndpoint } from 'src/utils/api';
import { getGlobalProject } from 'src/utils/globals';

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/events/' + project.UniqueCode, {
    getAvailableEvents: createControllerEndpoint<EventNamesResponse>('GET', '/metadata/events/names'),
    getInsights: createControllerEndpoint<EventsInsightsResponse>('GET', '/metadata/events/counts'),
});